export default "__VITE_ASSET__DWIA30ET__"